import { useState, useRef, useEffect } from "react"; 
import { Play, Pause, SkipForward, SkipBack } from "lucide-react";
import song1 from '../resources/1.mp3';
import song2 from '../resources/2.mp3';
import song3 from '../resources/3.mp3';
import song4 from '../resources/4.mp3';
import song5 from '../resources/5.mp3';
import song6 from '../resources/6.mp3';
import song7 from '../resources/7.mp3';
import song8 from '../resources/8.mp3';
import song9 from '../resources/9.mp3';
import song10 from '../resources/10.mp3';

export default function Audioplayer() {
    const [isPlaying, setIsPlaying] = useState(false);
    const [progress, setProgress] = useState(0); // Fortschritt des Zeitverlaufs
    const [volume, setVolume] = useState(1); // Lautstärke (0 bis 1)
    const [currentSongIndex, setCurrentSongIndex] = useState(7);
    const [isFirstLoad, setIsFirstLoad] = useState(true); 
    const audioRef = useRef(null);

    const songs = [
        song1,
        song2,
        song3,
        song4,
        song5,
        song6,
        song7,
        song8,
        song9,
        song10
    ];

    // Fortschritt des Songs
    useEffect(() => {
        const interval = setInterval(() => {
            if (audioRef.current) {
                setProgress((audioRef.current.currentTime / audioRef.current.duration) * 100);
            }
        }, 1000); // Alle 1 Sekunde den Fortschritt updaten

        return () => clearInterval(interval);
    }, [isPlaying]);

    const togglePlay = () => {
        if (!audioRef.current) return;
        if (isPlaying) {
            audioRef.current.pause();
        } else {
            audioRef.current.play();
        }
        setIsPlaying(!isPlaying);
    };

    const handleProgressChange = (event) => {
        const value = event.target.value;
        if (audioRef.current) {
            audioRef.current.currentTime = (value / 100) * audioRef.current.duration;
        }
        setProgress(value);
    };

    const handleVolumeChange = (event) => {
        const value = event.target.value;
        if (audioRef.current) {
            audioRef.current.volume = value;
        }
        setVolume(value);
    };
    
    const skipNext = () => {
        if (currentSongIndex < songs.length - 1) {
            setCurrentSongIndex(currentSongIndex + 1);
        } else {
            setCurrentSongIndex(0); // Zurück zum ersten Song
        }
        if (audioRef.current) {
            audioRef.current.play(); // Nächsten Song automatisch abspielen
        }
    };

    const skipBack = () => {
        if (currentSongIndex > 0) {
            setCurrentSongIndex(currentSongIndex - 1);
        } else {
            setCurrentSongIndex(songs.length - 1); // Zum letzten Song
        }
        if (audioRef.current) {
            audioRef.current.play(); // Nächsten Song automatisch abspielen
        }
    };

    useEffect(() => {
        if (isFirstLoad) {
            setIsFirstLoad(false); // Beim ersten Laden setzen wir den Zustand auf false
            return; // Verhindert das Abspielen des Songs beim ersten Laden
        }

        if (audioRef.current) {
            audioRef.current.load(); // Lädt die neue Quelle
            audioRef.current.play(); // Spielt die neue Quelle ab
            setIsPlaying(true); // Setzt den Zustand auf "spielt"
        }
    }, [currentSongIndex]);

    return (
        <div className="audio-player">
            <audio ref={audioRef} src={songs[currentSongIndex]} preload="auto" />

            <div className="progress-container">
                <input
                    type="range"
                    min="0"
                    max="100"
                    value={progress}
                    onChange={handleProgressChange}
                    className="progress-bar"
                />
            </div>

            <div className="audio-buttons">
                <button onClick={skipBack} className="skip-button">
                    <SkipBack size={30} />
                </button>

                <button onClick={togglePlay} className="play-button">
                    {isPlaying ? <Pause size={30}/> : <Play size={30} />}
                </button>

                <button onClick={skipNext} className="skip-button">
                    <SkipForward size={30} />
                </button>

                <div className="volume-container">
                    <label htmlFor="volume">🔊</label>
                    <input
                        type="range"
                        min="0"
                        max="1"
                        step="0.01"
                        value={volume}
                        onChange={handleVolumeChange}
                        className="volume-bar"
                        id="volume"
                    />
                </div>
            </div>
        </div>
    );
}
